import {StateCreator} from "zustand/vanilla";
import {DocumentTemplate, ProjectTemplate} from "@/pb/api/devplan/types/templates";
import {getDocumentTemplates, getProjectTemplates} from "@/app/data/actions";

export type TemplatesStoreState = {
  templates: Record<string, ProjectTemplate>;
  documentTemplates: Record<string, DocumentTemplate>;
  getTemplate(templateId: string): ProjectTemplate | undefined;
  fetchTemplates(): Promise<void>;
}

export const createTemplatesSlice: StateCreator<
  TemplatesStoreState,
  [],
  [],
  TemplatesStoreState
> = ((set, get) => ({
  templates: {},
  documentTemplates: {},
  getTemplate: templateId => get().templates[templateId],
  fetchTemplates: async () => {
    const docTemplates = await getDocumentTemplates()
    const templates = await getProjectTemplates()
    set((s) => ({
      ...s,
      templates: templates.reduce((res, t) => ({...res, [t.id]: t}), {} as Record<string, ProjectTemplate>)
    }))
    set((s) => ({
      ...s,
      documentTemplates: docTemplates.reduce((res, t) => ({...res, [t.id]: t}), {} as Record<string, DocumentTemplate>)
    }))
  }
}))